import { useMutation } from '@tanstack/react-query';
import { useRef, useState } from 'react';
import { searchDefaultValues } from '../form';
import { GET, GET_CLIAM_BY_DATE } from '../../../../services';
import { convertDateInputToPayload } from '../../../../functions/convert';

export const useGetClaimDate = ({ setSelectedRowKeys, searchParamState }) => {
  const [data, setData] = useState([]);
  const currentValue = useRef(searchDefaultValues);
  const { startDate, tel, fullname, customerCode } = searchParamState;
  const [startDateFrom, startDateTo] = startDate || ['', ''];
  const { mutate, isPending } = useMutation({
    mutationFn: async (value) => {
      const response = await GET(
        GET_CLIAM_BY_DATE({
          tel: tel || '',
          fullname: fullname || '',
          customerCode: customerCode || '',
          startDate: convertDateInputToPayload(startDateFrom),
          endDate: convertDateInputToPayload(startDateTo),
        }),
      );
      currentValue.current = value;
      return response.result.items || [];
    },
    onSuccess: (response) => {
      setSelectedRowKeys((prev) => {
        return prev?.filter((claimId) => response?.some((newRow) => newRow?.claimId === claimId));
      });
      setData(response);
    },
  });
  const onFetch = () => mutate(currentValue.current);
  return { data, setData, loading: isPending, mutate, onFetch };
};
